import { LazyAction, LazyModule } from 'owa-bundling';
import { subscribe } from 'satcheljs/lib/legacy/stitch';
import { runAfterInitialRender } from 'owa-delayed-initialization';
export { default as initializeFocusedInboxConfig } from './actions/initializeFocusedInboxConfig';
var lazyModule = new LazyModule(function () {
    return System.import(
    /* webpackChunkName: "FocusedInboxConfigActions", webpackPrefetch: true */ './lazyIndex');
});
export var lazySetFocusedInboxOnOff = new LazyAction(lazyModule, function (m) { return m.setFocusedInboxOnOff; });
// Initialize stitch to listen to action in Options that toggles Focused Inbox
runAfterInitialRender(function () {
    // Type safety without pulling in a string reference and all the code that goes with it
    var stitchName = 'saveFocusInboxOptionStitchName';
    subscribe(stitchName, function (isFocusedInboxEnabled) {
        return lazySetFocusedInboxOnOff.importAndExecute(isFocusedInboxEnabled, true /* skipServiceRequest */);
    });
});
//# sourceMappingURL=index.js.map